"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _uiSelectors = require("../../store/ui/uiSelectors");
var _constants = require("../../utils/constants");
var _FullSpecsBody = _interopRequireDefault(require("./FullSpecs/FullSpecsBody"));
var _UpsellDetailsBody = _interopRequireDefault(require("./UpsellDetails/UpsellDetailsBody"));
var _UpsellConnectivityPlanBody = _interopRequireDefault(require("./UpsellConnectivityPlan/UpsellConnectivityPlanBody"));
var _InsuranceDetailsBody = _interopRequireDefault(require("./InsuranceDetails/InsuranceDetailsBody"));
var _WarningScreenBody = _interopRequireDefault(require("./WarningScreen.js/WarningScreenBody"));
var _useAppSelector = require("../../hooks/useAppSelector");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const DynamicPageBodyFactory = () => {
  const currentDynamicPage = (0, _useAppSelector.useAppSelector)(_uiSelectors.selectCurrentDynamicPage);
  switch (currentDynamicPage) {
    case _constants.DYNAMIC_PAGES.FULL_SPECS:
      return /*#__PURE__*/_react.default.createElement(_FullSpecsBody.default, null);
    case _constants.DYNAMIC_PAGES.UPSELL_DETAILS:
      return /*#__PURE__*/_react.default.createElement(_UpsellDetailsBody.default, null);
    case _constants.DYNAMIC_PAGES.UPSELL_CONNECTIVITY_PLAN:
      return /*#__PURE__*/_react.default.createElement(_UpsellConnectivityPlanBody.default, null);
    case _constants.DYNAMIC_PAGES.INSURANCE_DETAILS:
      return /*#__PURE__*/_react.default.createElement(_InsuranceDetailsBody.default, null);
    case _constants.DYNAMIC_PAGES.WARNING_SCREEN:
      return /*#__PURE__*/_react.default.createElement(_WarningScreenBody.default, null);
    default:
      return null;
  }
};
var _default = DynamicPageBodyFactory;
exports.default = _default;